import useCompanies from 'contexts/basicData/useCompanies';
import useZipCodeAreas from 'hooks/useZipCodeAreas';

const useIsInLogisticVicinity = () => {
  const { isOutsideAllowedRange } = useZipCodeAreas();
  const { companies } = useCompanies();
  const firstLogisticsCompany = companies.find(
    (c) => c.isLogisticsCenter && c.active
  );
  const firstLogisticsCompanyZipCode = firstLogisticsCompany?.zip;

  const isInLogisticsVicinity = (zipCode: string) => {
    if (!zipCode) return false;

    if (!firstLogisticsCompanyZipCode) return false;

    if (!isOutsideAllowedRange(zipCode, firstLogisticsCompanyZipCode)) {
      return true;
    }

    return false;
  };
  return isInLogisticsVicinity;
};

export default useIsInLogisticVicinity;
